import { render } from "./tickets-list-recurring.vue?vue&type=template&id=31fffa18"
import script from "./tickets-list-recurring.vue?vue&type=script&lang=js"
export * from "./tickets-list-recurring.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__